import { useStaticQuery, graphql } from 'gatsby'
import { mapCraft } from './mappings'

const query = graphql`
{
  craft {
    entry(section: careers) {
      ...on Craft_Careers {
        title
        masthead {
          heading
          subheading {
            content
          }
          image {
            title
            url
          }
          backgroundColor
        }
        sections {
          ...textBlockFields
          ...htmlBlockFields
          ...quoteBlockFields
          ...processBlockFields
          ...insightBlockFields
          ...imageBlockFields
          ...doubleImageBlockFields
          ...comboBlockFields
          ...showcaseBlockFields
        }
        metadata {
          ...metadataFields
        }
      }
    }
  }
}
`

export const useCraft = () => {
  const { craft } = useStaticQuery(query)
  return mapCraft(craft)
}
